const styleOverrides = {
  root: {
    padding: '4px 0 3px'
  },
  formControl: {
    'label + &': {
      marginTop: 10
    }
  },
  inputSizeSmall: {
    paddingTop: 6
  },
  underline: {
    '&:hover:not(.Mui-disabled):before': {
      borderBottomWidth: 0.75
    },
    '&:after': {
      borderBottomWidth: 1.2
    }
  },
  multiline: {
    padding: '10px 0 10px'
  }
};
export default {
  styleOverrides
};